// On-chain + API configuration. Fill REACT_APP_STAMP_TOKEN in frontend/.env to
// enable real balance reads and real burns. No key needed for public RPC reads.

export const CHAIN_ID = parseInt(process.env.REACT_APP_CHAIN_ID || "56", 10);

export const NETWORKS = {
  56: {
    chainIdHex: "0x38",
    name: "BNB Smart Chain",
    rpc: ["https://bsc-dataseed.binance.org", "https://bsc-dataseed1.defibit.io"],
    explorer: "https://bscscan.com",
    symbol: "BNB",
  },
  97: {
    chainIdHex: "0x61",
    name: "BNB Smart Chain Testnet",
    rpc: ["https://data-seed-prebsc-1-s1.binance.org:8545"],
    explorer: "https://testnet.bscscan.com",
    symbol: "tBNB",
  },
};

export const NET = NETWORKS[CHAIN_ID] || NETWORKS[56];

export const STAMP_TOKEN = (process.env.REACT_APP_STAMP_TOKEN || "").trim();
export const FLAP_FACTORY = (process.env.REACT_APP_FLAP_FACTORY || "").trim();
export const BURN_ADDRESS = "0x000000000000000000000000000000000000dEaD";
export const TOKEN_CONFIGURED = /^0x[a-fA-F0-9]{40}$/.test(STAMP_TOKEN);

export const ERC20_ABI = [
  "function decimals() view returns (uint8)",
  "function symbol() view returns (string)",
  "function balanceOf(address) view returns (uint256)",
  "function transfer(address to, uint256 amount) returns (bool)",
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const explorerTx = (h) => `${NET.explorer}/tx/${h}`;
export const explorerAddr = (a) => `${NET.explorer}/address/${a}`;

// --- flap.sh Portal (in-app token launch) ---
// Deployed addresses per flap.sh docs. Mainnet (56) values are live.
export const FLAP = {
  56: {
    portal: "0xe2cE6ab80874Fa9Fa2aAE65D277Dd6B8e65C9De0",
    standardImpl: "0x8b4329947e34b6d56d71a3385cac122bade7d78d", // suffix 8888
    taxImpl: "0x024f18294970B5c76c0691b87f138A0317156422",      // suffix 7777
    tokenPage: "https://flap.sh/bnb",
  },
  97: {
    portal: "0x5bEacaF7ABCbB3aB280e80D007FD31fcE26510e9",
    standardImpl: "0x87D5f292ba33011997641C7a7Bd2b17799aaA814", // suffix 8888
    taxImpl: "0xE6Ff967a887084c16D0fD71548CF709542cc1557",      // suffix 7777
    tokenPage: "https://flap.sh/bnb",
  },
};
export const FLAP_NET = FLAP[CHAIN_ID] || FLAP[56];

// Portal ABI (human-readable). Enums are uint8.
export const PORTAL_ABI = [
  "function newTokenV6((string name,string symbol,string meta,uint8 dexThresh,bytes32 salt,uint8 migratorType,address quoteToken,uint256 quoteAmt,address beneficiary,bytes permitData,bytes32 extensionID,bytes extensionData,uint8 dexId,uint8 lpFeeProfile,uint16 buyTaxRate,uint16 sellTaxRate,uint64 taxDuration,uint64 antiFarmerDuration,uint16 mktBps,uint16 deflationBps,uint16 dividendBps,uint16 lpBps,uint256 minimumShareBalance,address dividendToken,address commissionReceiver,uint8 tokenVersion) params) payable returns (address token)",
  "function getTokenV6(address token) view returns ((uint8 status,uint256 reserve,uint256 circulatingSupply,uint256 price,uint8 tokenVersion,uint256 r,uint256 h,uint256 k,uint256 dexSupplyThresh,address quoteTokenAddress,bool nativeToQuoteSwapEnabled,bytes32 extensionID,uint256 taxRate,address pool,uint256 progress) state)",
  "function swapExactInput((address inputToken,address outputToken,uint256 inputAmount,uint256 minOutputAmount,bytes permitData) params) payable returns (uint256 outputAmount)",
];

// enum values
export const PORTAL_ENUMS = {
  dexThresh_TWO_THIRDS: 0,
  migrator_V2: 1,
  dexId_DEX0: 0,
  lpFee_STANDARD: 0,
  tokenVersion_V2_PERMIT: 2,
  tokenVersion_TAXED_V3: 6,
};
export const VANITY_STANDARD_SUFFIX = "8888";
export const VANITY_TAX_SUFFIX = "7777";
